/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Aria_DeleteInputs */

const vi_common_aria_delete = /** @type {(inputs: Common_Aria_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xóa`)
};

/**

* @param {Common_Aria_DeleteInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const common_aria_delete = /** @type {((inputs?: Common_Aria_DeleteInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Aria_DeleteInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_common_aria_delete(inputs)
});